import React from 'react';
import { FaBox, FaBoxes, FaCashRegister, FaClipboardList, FaFileInvoiceDollar, FaFunnelDollar, FaHistory, FaHome, FaHospitalUser, FaMoneyCheckAlt, FaNotesMedical, FaPeopleCarry, FaPrescriptionBottle, FaRegSun, FaSlidersH, FaUser, FaUserMd, FaUsers, FaWarehouse } from "react-icons/fa";
import { FiCalendar, FiMessageCircle, FiRefreshCw, FiFileText } from "react-icons/fi";

const iconMap = {
  dashboard: FaHome,
  staffUser: FaUser,
  users: FaUsers,
  chats: FiMessageCircle,
  calendar: FiCalendar,
  referral: FiRefreshCw,
  settings: FaRegSun,
  file: FiFileText,
  sales: FaCashRegister,
  purchase: FaBox,
  stock: FaBoxes,
  items: FaSlidersH,
  medicine: FaNotesMedical,
  inventory: FaWarehouse,
  orders: FaClipboardList,
  supplier: FaPeopleCarry,
  transaction: FaMoneyCheckAlt,
  ledger: FaFileInvoiceDollar,
  patient_accounts: FaHospitalUser,
  pharma_doctors: FaUserMd,
  OTC: FaPrescriptionBottle,
  tax: FaFunnelDollar,
  transactions: FaHistory
};
const IconRenderer = ({ iconName, className }) => {
  const IconComponent = iconMap[iconName];
  return IconComponent ? <IconComponent className={className} /> : null;
};

export default IconRenderer;
